/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.button`
  color: ${({ pressed }) => (pressed ? Palette.Primary._900 : Palette.PrimaryGray._500)};
  padding: 6px 0 4px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  height: 32px;

  border: none;
  background: #fff;
  cursor: pointer;

  :hover {
    color: ${Palette.Primary._500};
    border-bottom: 2px solid ${Palette.PrimaryGray._200};
  }
  :active {
    color: ${Palette.PrimaryGray._900};
    border-bottom: 2px solid ${Palette.Primary._500};
  }
  :disabled {
    cursor: not-allowed;
    color: ${Palette.PrimaryGray._500};
    border-bottom: 2px solid transparent;
    opacity: 0.5;
  }
  border-bottom: ${({ pressed }) =>
    pressed ? `2px solid ${Palette.Primary._500}` : `2px solid transparent`};
  border: ${({ error }) => error && '1px solid red'};
  transition: all 0.2s;
`;
